import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { FaFile, FaDownload, FaTrash } from 'react-icons/fa';

function FileViewer({ files, onDelete }) {
  const { user } = useAuth();

  const downloadFile = (file) => {
    if (!user) {
      alert('Dosyaları indirmek için giriş yapmalısınız');
      return;
    }

    if (file && file.url) {
      const link = document.createElement('a');
      link.href = file.url;
      link.download = file.name || 'dosya';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  if (!files || !Array.isArray(files)) {
    return null;
  }

  return (
    <div className="space-y-2">
      {files.map((file, index) => (
        <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
          <div className="flex items-center">
            <FaFile className="text-indigo-500 mr-2" />
            <span className="text-sm text-gray-600 truncate">
              {file.name || `Dosya ${index + 1}`}
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <button
              onClick={() => downloadFile(file)}
              className="p-2 text-indigo-600 hover:text-indigo-800 transition-colors"
              title="İndir"
            >
              <FaDownload />
            </button>
            {onDelete && (
              <button
                onClick={() => onDelete(index)}
                className="p-2 text-red-600 hover:text-red-800 transition-colors"
                title="Sil"
              >
                <FaTrash />
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default FileViewer; 